import { render, staticRenderFns } from "./SurveyInformation.vue?vue&type=template&id=4b120e26&scoped=true&"
import script from "./SurveyInformation.vue?vue&type=script&lang=js&"
export * from "./SurveyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b120e26",
  null
  
)

export default component.exports